import { calculateUsageCost, TieredPriceProductId } from "@project/common";
import { type UsageCardLoaderProps, UsageCard } from "./UsageCard.js";
import { useIntl } from "react-intl";
import { IconStack2 } from "@tabler/icons-react";
import { INTERNATIONALIZED_UNIT_LABELS } from "../../../constants/productLabels.js";
import { useTilesRequestsUsageSum } from "./hooks/fetchSums.js";
import { useProductDescriptions, useProductNames } from "./hooks/productLabels.js";

export const TilesRequestsUsageCard = ({
  from,
  to,
  interval,
  apiKeyId,
  productId,
  isLoadingSubscriptions,
}: UsageCardLoaderProps) => {
  const intl = useIntl();
  const getName = useProductNames();
  const getDescription = useProductDescriptions();
  const {
    usageSum,
    isLoadingTilesUsage,
    isErrorTilesUsage,
  } = useTilesRequestsUsageSum({ from, to, interval, apiKeyId });
  const unitLabel = intl.formatMessage(INTERNATIONALIZED_UNIT_LABELS.tileset);

  return (
    <UsageCard
      productId={productId}
      usageSum={usageSum}
      unitLabel={unitLabel}
      icon={<IconStack2 />}
      iconColor="purpleBlue.2"
      isError={isErrorTilesUsage}
      isLoading={isLoadingTilesUsage || isLoadingSubscriptions}
      usageCost={calculateUsageCost(usageSum, productId)}
      defaultProductId={TieredPriceProductId.TieredTileUsage}
      name={getName(TieredPriceProductId.TieredTileUsage)}
      description={getDescription(TieredPriceProductId.TieredTileUsage)}
    />
  );
};
